import React, { useMemo } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import Chatbot from '@/components/Chat';
import { EnvironmentAlert } from '@/components/EnvironmentAlert';
import env from '@/env';
import { Grid, Layout } from 'antd';
import WithRole from '../roles/WithRole';
import { useAuth } from '../../contexts/Auth';
import { SideBar, TopBar } from '../../components/Layout';

const { Content } = Layout;

const PrivateRoute: React.FC<any> = ({ role }) => {
    const { isAuth, data, isLoading } = useAuth();
    const location = useLocation();

    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();
    const isMobile = !screens.lg;

    if (!isAuth) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (role && role.length > 0 && data.role?.length > 0) {
        const hasPermission = data.role?.some((userRole: { type: string }) =>
            role.includes(userRole?.type),
        );

        if (!hasPermission) {
            return <Navigate to="/" replace />;
        }
    }

    return (
        <Layout hasSider>
            {env.API_URL?.includes('staging') && <EnvironmentAlert />}

            <SideBar />

            <Layout>
                <TopBar />
                <Content
                    style={{
                        overflow: 'hidden',
                        margin: `${isMobile ? '70px' : '24px'} 16px 0px`,
                    }}
                >
                    <Outlet />
                    <Chatbot />
                </Content>
            </Layout>
        </Layout>
    );
};

export default PrivateRoute;
